import { render, staticRenderFns } from "./value.vue?vue&type=template&id=c900ee18&scoped=true&lang=pug"
import script from "./value.vue?vue&type=script&lang=js"
export * from "./value.vue?vue&type=script&lang=js"
import style0 from "./value.vue?vue&type=style&index=0&id=c900ee18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c900ee18",
  null
  
)

export default component.exports